export default __webpack_public_path__ + "static/media/rose.ebfbf5dd.svg";